import React from 'react';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export const Problem = () => {
  return <section className="py-16 md:py-24 px-6 bg-white/50" data-id="element-70">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-72">
          <div className="p-4 bg-beige rounded-full text-terracotta" data-id="element-73">
            <Moon size={32} data-id="element-74" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="space-y-6 text-lg text-charcoal/80 leading-relaxed" data-id="element-75">
          <p data-id="element-76">
            Llevas meses sobreviviendo a base de café y siestas de 20 minutos.
            Has probado a sacarlo a pasear en el coche de madrugada, a darle
            tomas infinitas y a buscar respuestas en foros que solo te confunden
            más.
          </p>
          <p className="font-medium text-charcoal text-xl font-serif" data-id="element-77">
            El problema no es tu bebé. El problema es que te han enseñado
            métodos rígidos que no respetan su biología ni tu realidad en
            España.
          </p>
          <p data-id="element-78">
            Tu hijo no sabe cómo cerrar sus ciclos de sueño porque depende de ti
            para cada micro-despertar. Estás agotada, irritable y sientes que
            estás fallando, pero la realidad es que nadie te ha dado el mapa
            correcto.
          </p>
        </motion.div>
      </div>
    </section>;
};